import type {IUserAbstract} from "../objects/User";

export const USERS_LIST_PATH = "/us";

export const USER_DETAIL_VIEW_PATH: string = "/us/:username";
export function GetUserDetailViewPath(user: IUserAbstract | string) {
    return USER_DETAIL_VIEW_PATH.replace(":username", typeof user === 'string' ? user : user.username);
}

export const USER_CREATE_VIEW_PATH = "/us/create";

export const USER_EDIT_VIEW_PATH: string = "/us/:username/edit";
export function GetEditUserViewPath(user: IUserAbstract) {
    return USER_EDIT_VIEW_PATH.replace(":username", user.username);
}